import React from 'react';

export default function IcNavChevronIcon(props) {
  return (
    <svg
      viewBox="0 0 6 12"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      {...props}
    >
      {/* Generator: Sketch 57.1 (83088) - https://sketch.com */}
      <title>ic_nav-chevron</title>
      <desc>Created with Sketch.</desc>
      <g
        id="ic_nav-chevron"
        stroke="none"
        strokeWidth={1}
        fill="none"
        fillRule="evenodd"
      >
        <polyline
          stroke="#999999"
          strokeWidth={2}
          transform="translate(3.000000, 6.000000) scale(-1, 1) translate(-3.000000, -6.000000) "
          points="6 0 0 6 6 12"
        />
      </g>
    </svg>
  );
}
